
import transform from 'essential/transform'

const zoom = (img$: HTMLImageElement) => {
  const bounding = img$.getBoundingClientRect()
  const outer$ = document.createElement('div')
  let timer = 0
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let destroyTransform = () => {
  }

  const remove = () => {
    outer$.removeEventListener('click', remove)
    document.body.removeChild(outer$)
    destroyTransform()
    clearTimeout(timer)
  }

  outer$.addEventListener('click', remove)
  outer$.classList.add('spread', 'outer')
  outer$.style.cssText = `
    z-index: 1;
    width: ${img$.width}px;
    height: ${img$.height}px;
    left: ${bounding.x}px;
    top: ${bounding.y}px;
  `

  const zoomImg$ = document.createElement('img')
  zoomImg$.src = img$.src
  zoomImg$.className = 'zoomImg'

  document.body.appendChild(outer$)

  setTimeout(() => {
    outer$.classList.add('expand')

    timer = window.setTimeout(() => {
      outer$.appendChild(zoomImg$)
    }, 200)

    destroyTransform = transform(zoomImg$, {
      onTransform (a) {
        zoomImg$.style.transform = a.toString()
      },
    })
  }, 0)
}

export default {
  name: 'ImgPreviewer',
  setup () {
    const toggle = (e: MouseEvent) => {
      const target = e.target as Element
      if (target.tagName !== 'IMG') return
      zoom(target as HTMLImageElement)
    }

    return {
      toggle,
    }
  },
}
